import React, { Component } from "react";
import { connect } from "react-redux";
import withTranslationWrapper from "../../HOC/withTranslation";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import {
  fetchCampaignOffer,
  fetchCostPerKmCurrent,
  fetchCostPerKmPrevious,
  fetchFleetAvailability,
  fetchImmediateAttention,
  fetchNotVisitedRecently,
  fetchPmCompliance,
  fetchUpcomingMaintenance,
  fetchUnexpectedBreakdowns,
  fetchWorkshopTat,
} from "./api";
import CampaignOffer from "./Components/CampaignOffer";
import CostPerKm from "./Components/CostPerKm";
import FleetAvailability from "./Components/FleetAvailability";
import FleetHealthScore from "./Components/FleetHealthScore";
import ImmediateAttention from "./Components/ImmediateAttention";
import NotVisitedRecently from "./Components/NotVisitedRecently";
import ScheduleBookingModal from "../MissedOpportunities/ScheduleBookingModal";
import PmCompliance from "./Components/PmCompliance";
import UnexpectedBreakdowns from "./Components/UnexpectedBreakdowns";
import UpcomingMaintenance from "./Components/UpcomingMaintenance";
import VehicleCondition from "./Components/VehicleCondition";
import WorkshopSla from "./Components/WorkshopSla";
import WorkshopTat from "./Components/WorkshopTat";
import "./style.scss";

class FleetHealth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaders: {
        upcoming: true,
        campaign: true,
        availability: true,
        pmCompliance: true,
        workshopTat: true,
        notVisited: true,
        immediateAttention: true,
        costPerKm: true,
        breakdowns: true,
      },
      upcoming: null,
      campaign: null,
      availability: null,
      pmCompliance: null,
      workshopTat: null,
      notVisited: null,
      immediateAttention: null,
      costPerKm: null,
      breakdowns: null,
      // Pending API widgets keep placeholders until endpoints exist
      healthScore: null,
      workshopSla: null,
      vehicleCondition: null,
      bookingModalOpen: false,
      bookingPrediction: null,
      bookingGroup: null,
    };
  }

  componentDidMount() {
    this.loadDashboard();
  }

  setLoader = (key, value) => {
    this.setState((prev) => ({
      loaders: { ...prev.loaders, [key]: value },
    }));
  };

  loadDashboard = () => {
    this.loadUpcoming();
    this.loadCampaign();
    this.loadAvailability();
    this.loadPmCompliance();
    this.loadWorkshopTat();
    this.loadNotVisited();
    this.loadImmediateAttention();
    this.loadCostPerKm();
    this.loadBreakdowns();
  };

  loadUpcoming = () => {
    this.setLoader("upcoming", true);
    fetchUpcomingMaintenance()
      .then((res) => {
        this.setState((prev) => ({
          upcoming: res,
          loaders: { ...prev.loaders, upcoming: false },
        }));
      })
      .catch(() => this.setLoader("upcoming", false));
  };

  loadCampaign = () => {
    this.setLoader("campaign", true);
    fetchCampaignOffer()
      .then((res) => {
        this.setState((prev) => ({
          campaign: res,
          loaders: { ...prev.loaders, campaign: false },
        }));
      })
      .catch(() => this.setLoader("campaign", false));
  };

  loadAvailability = () => {
    this.setLoader("availability", true);
    fetchFleetAvailability()
      .then((res) => {
        this.setState((prev) => ({
          availability: res,
          loaders: { ...prev.loaders, availability: false },
        }));
      })
      .catch(() => this.setLoader("availability", false));
  };

  loadPmCompliance = () => {
    this.setLoader("pmCompliance", true);
    fetchPmCompliance()
      .then((res) => {
        const payload =
          res?.data &&
          typeof res.data === "object" &&
          res.pmCompliancePercent === undefined
            ? res.data
            : res;
        this.setState((prev) => ({
          pmCompliance: payload || null,
          loaders: { ...prev.loaders, pmCompliance: false },
        }));
      })
      .catch(() => this.setLoader("pmCompliance", false));
  };

  loadWorkshopTat = () => {
    this.setLoader("workshopTat", true);
    fetchWorkshopTat()
      .then((res) => {
        this.setState((prev) => ({
          workshopTat: res,
          loaders: { ...prev.loaders, workshopTat: false },
        }));
      })
      .catch(() => this.setLoader("workshopTat", false));
  };

  loadNotVisited = () => {
    this.setLoader("notVisited", true);
    fetchNotVisitedRecently()
      .then((res) => {
        this.setState((prev) => ({
          notVisited: res,
          loaders: { ...prev.loaders, notVisited: false },
        }));
      })
      .catch(() => this.setLoader("notVisited", false));
  };

  loadImmediateAttention = () => {
    this.setLoader("immediateAttention", true);
    fetchImmediateAttention()
      .then((res) => {
        this.setState((prev) => ({
          immediateAttention: res,
          loaders: { ...prev.loaders, immediateAttention: false },
        }));
      })
      .catch(() => this.setLoader("immediateAttention", false));
  };

  // fmd/14 = current (3 months), fmd/26 = previous (6-month baseline)
  loadCostPerKm = () => {
    this.setLoader("costPerKm", true);
    Promise.all([fetchCostPerKmCurrent(), fetchCostPerKmPrevious()])
      .then(([current, previous]) => {
        this.setState((prev) => ({
          costPerKm: { current, previous },
          loaders: { ...prev.loaders, costPerKm: false },
        }));
      })
      .catch(() => this.setLoader("costPerKm", false));
  };

  loadBreakdowns = () => {
    this.setLoader("breakdowns", true);
    fetchUnexpectedBreakdowns()
      .then((res) => {
        this.setState((prev) => ({
          breakdowns: res,
          loaders: { ...prev.loaders, breakdowns: false },
        }));
      })
      .catch(() => this.setLoader("breakdowns", false));
  };

  handleScheduleAll = () => {
    this.props.dispatch(notifySuccess("bookingRequestEmailed"));
  };

  handleBookAppointment = () => {
    this.props.dispatch(notifySuccess("bookAppointmentRequested"));
  };

  // Immediate Attention rows carry the raw fmd/25 prediction in `raw`.
  handleBookService = (item) => {
    const prediction = item?.raw || item;
    if (!prediction) return;
    this.setState({
      bookingModalOpen: true,
      bookingPrediction: prediction,
      bookingGroup: {
        plateNumber: item?.plate || prediction?.plateNumber || "",
      },
    });
  };

  closeBookingModal = () => {
    this.setState({
      bookingModalOpen: false,
      bookingPrediction: null,
      bookingGroup: null,
    });
  };

  handleExport = () => {
    this.props.dispatch(notifySuccess("exportStarted"));
  };

  handleApiPending = () => {
    this.props.dispatch(notifyError("apiPending"));
  };

  render() {
    const { translate } = this.props;
    const { loaders } = this.state;

    return (
      <div className="fleet-health-grid">
        <div className="fh-row fh-row-score">
          <FleetHealthScore
            translate={translate}
            data={{
              availability: this.state.availability,
              pmCompliance: this.state.pmCompliance,
              breakdowns: this.state.breakdowns,
              costPerKm: this.state.costPerKm,
            }}
            loading={
              loaders.availability ||
              loaders.pmCompliance ||
              loaders.breakdowns ||
              loaders.costPerKm
            }
          />
          <WorkshopTat
            translate={translate}
            data={this.state.workshopTat}
            loading={loaders.workshopTat}
          />
             <CampaignOffer
            translate={translate}
            data={this.state.campaign}
            loading={loaders.campaign}
            onBook={this.handleBookAppointment}
          />
        </div>

        <div className="fh-row fh-row-kpi">
          <FleetAvailability
            translate={translate}
            data={this.state.availability}
            loading={loaders.availability}
          />
          <PmCompliance
            translate={translate}
            data={this.state.pmCompliance}
            loading={loaders.pmCompliance}
          />
          <UnexpectedBreakdowns
            translate={translate}
            data={this.state.breakdowns}
            loading={loaders.breakdowns}
          />
          <CostPerKm
            translate={translate}
            data={this.state.costPerKm}
            loading={loaders.costPerKm}
          />
        </div>

        <div className="fh-row fh-row-lists">
          <UpcomingMaintenance
            translate={translate}
            data={this.state.upcoming}
            loading={loaders.upcoming}
            onScheduleAll={this.handleScheduleAll}
          />
                 <NotVisitedRecently
            translate={translate}
            data={this.state.notVisited}
            loading={loaders.notVisited}
            onScheduleAll={this.handleScheduleAll}
            onExport={this.handleExport}
          />

          <ImmediateAttention
            translate={translate}
            data={this.state.immediateAttention}
            loading={loaders.immediateAttention}
            onBookService={this.handleBookService}
            onViewAll={this.handleApiPending}
          />
        </div>

        {/* API pending — kept for later
        <WorkshopSla ... />
        <VehicleCondition ... />
        */}

        {this.state.bookingModalOpen ? (
          <ScheduleBookingModal
            prediction={this.state.bookingPrediction}
            group={this.state.bookingGroup}
            onClose={this.closeBookingModal}
            onSuccess={this.closeBookingModal}
            translate={translate}
            themecolors={this.props.themecolors}
            logInUser={this.props.logInUser}
            ServerSetting={this.props.ServerSetting}
            vehicles={this.props.vehicles}
            dispatch={this.props.dispatch}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
  ServerSetting: state.ServerSetting,
  vehicles: state.vehicles,
});

export default connect(mapStateToProps)(withTranslationWrapper(FleetHealth));
